import { render, staticRenderFns } from "./status.vue?vue&type=template&id=b2ceee36&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"
import style0 from "./status.vue?vue&type=style&index=0&id=b2ceee36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ceee36",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/build/components/Heading.vue').default,BaseAlert: require('/build/components/BaseAlert.vue').default,BaseIcon: require('/build/components/BaseIcon.vue').default,BaseButton: require('/build/components/BaseButton.vue').default})
